import { useAppDispatch, useAppSelector } from "@/app_redux/hooks/root_hook";
import { setLoading } from "@/app_redux/reducers/loading_reducer";
import { LoadingReducerState } from "@/app_redux/reducers/reducer_interface";
import { useEffect, useState } from "react";

export const useLoader = (loadingKey: keyof LoadingReducerState, callback?: (isLoading: boolean) => any) => {
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const loaders = useAppSelector((state) => state?.loading);

  const dispatch = useAppDispatch();

  useEffect(() => {
    if (callback) {
      callback(loaders[loadingKey]);
    }
    setIsLoading(loaders[loadingKey]);
  }, [loaders[loadingKey]]);

  const _enable = () => {
    dispatch(
      setLoading({
        key: loadingKey,
        status: true,
      }),
    );
  };

  const _disable = () => {
    dispatch(
      setLoading({
        key: loadingKey,
        status: false,
      }),
    );
  };

  return isLoading;
};
